import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const MediaPreviewSlider = ({ mediaFiles }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!mediaFiles || mediaFiles.length === 0) return null;

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? mediaFiles.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === mediaFiles.length - 1 ? 0 : prev + 1));
  };

  const current = mediaFiles[currentIndex];

  return (
    <div className="slider-container">
      {/* Media */}
      {current.mediaType === 'image' ? (
        <img src={current.previewUrl} className="slider-media" />
      ) : (
        <video controls className="slider-media">
          <source src={current.previewUrl} />
        </video>
      )}

      {/* Arrows */}
      {mediaFiles.length > 1 && (
        <>
          <button className="slider-arrow left" onClick={goPrev}>
            <ArrowLeft size={20} />
          </button>
          <button className="slider-arrow right" onClick={goNext}>
            <ArrowRight size={20} />
          </button>
        </>
      )}

      {/* Dots */}
      {mediaFiles.length > 1 && (
        <div className="slider-dots">
          {mediaFiles.map((_, idx) => (
            <span
              key={idx}
              className={`slider-dot ${idx === currentIndex ? 'active' : ''}`}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default MediaPreviewSlider;
